import { logger } from "../logger";
import { captureEvent } from "./analytics";
import { captureMetaEvent } from "./meta-pixel";

/**
 * App-wide event tracking. Every funnel event (assessment_started,
 * step_completed, consultation_requested, hero_video_variant_assigned, ...) flows
 * through here and out to the configured analytics destinations: PostHog (all
 * events) and the Meta Pixel (funnel/conversion events only).
 *
 * Previously this buffered events and discarded them in production — the buffer
 * is gone; events now forward straight to captureEvent()/captureMetaEvent(),
 * each of which no-ops until its destination is configured, so this is safe
 * with or without any keys set.
 */
class Telemetry {
  private static instance: Telemetry;
  private isEnabled = true;

  static getInstance(): Telemetry {
    if (!Telemetry.instance) {
      Telemetry.instance = new Telemetry();
    }
    return Telemetry.instance;
  }

  track(eventName: string, properties: Record<string, unknown> = {}): void {
    if (!this.isEnabled) return;

    try {
      captureEvent(eventName, properties);
      captureMetaEvent(
        eventName,
        typeof properties.event_id === "string"
          ? properties.event_id
          : undefined,
      );
    } catch (error) {
      logger.error("Failed to record telemetry event", {
        event: eventName,
        error: error instanceof Error ? error.message : String(error),
      });
    }

    if (import.meta.env.DEV) {
      console.log("Telemetry event:", eventName, properties);
    }
  }

  enable(): void {
    this.isEnabled = true;
  }

  disable(): void {
    this.isEnabled = false;
  }
}

export const telemetry = Telemetry.getInstance();
